import React from 'react'
import FiltersIconSVG from "../../../assets/icons/filters-icon.svg"
export const FiltersIcon:React.FC = () => {
  return (
    <img src={FiltersIconSVG} alt="" className="w-[22px] h-[22px] cursor-pointer" />
  )
}
